import PropTypes from 'prop-types';
import FaqQuestion from "components/ui/Faq/FaqQuestion";

const ParagraphFAQ = ({ questions }) => {
  return (
    <>
      { questions.map(question => <FaqQuestion key={ question.id }
                                               question={ question.title.value }
                                               answer={ question.field_faq_question_answer.value }/>) }
    </>
  )
}

ParagraphFAQ.propTypes = {
  questions: PropTypes.array,
}

export default ParagraphFAQ;
